// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 600;
}
.modal-title .title-icon {
  font-size: 1.2rem;
}

.modal-form {
  padding: 1.5rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  opacity: 0.8;
  padding-left: 4px;
}
.field-label.required::after {
  content: " *";
  color: var(--ion-color-danger);
}

.field-item {
  margin-top: 2px;
}

.field-error {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 4px;
  color: var(--ion-color-warning);
  font-size: 1rem;
}
.field-error ion-icon {
  font-size: 1.5rem;
}

.toggle-item {
  --background: rgba(var(--ion-color-secondary-contrast-rgb), 0.06);
  --border-radius: 8px;
  --padding-start: 12px;
  border-radius: 8px;
}
.toggle-item .toggle-icon {
  font-size: 2rem;
  color: var(--ion-color-secondary-contrast);
}
.toggle-item ion-label {
  color: var(--ion-color-secondary-contrast) !important;
}
.toggle-item ion-toggle {
  --track-background: var(--ion-color-toggle-track);
  --track-background-checked: var(--ion-color-medium);
  --handle-background: var(--ion-color-secondary-contrast);
  --handle-background-checked: var(--ion-color-secondary-contrast);
}

.collapsable-section .field-item {
  --min-height: 52px;
}
.collapsable-section .empty-label {
  font-size: 0.85rem;
  font-style: italic;
  opacity: 0.6;
}
.collapsable-section .add-btn {
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modals/group-modal/group-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;AADF;AAGE;EACE,iBAAA;AADJ;;AAKA;EACE,iEAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,0CAAA;AAFJ;AAKE;EACE,qDAAA;AAHJ;AAME;EACE,iDAAA;EACA,mDAAA;EACA,wDAAA;EACA,gEAAA;AAJJ;;AASE;EACE,kBAAA;AANJ;AASE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AAPJ;AAUE;EACE,YAAA;AARJ","sourcesContent":[".modal-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n\n  .title-icon {\n    font-size: 1.2rem;\n  }\n}\n\n.modal-form {\n  padding: 1.5rem 1.2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.field-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  opacity: 0.8;\n  padding-left: 4px;\n\n  &.required::after {\n    content: ' *';\n    color: var(--ion-color-danger);\n  }\n}\n\n.field-item {\n  margin-top: 2px;\n}\n\n.field-error {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-left: 4px;\n  color: var(--ion-color-warning);\n  font-size: 1rem;\n\n  ion-icon {\n    font-size: 1.5rem;\n  }\n}\n\n.toggle-item {\n  --background: rgba(var(--ion-color-secondary-contrast-rgb), 0.06);\n  --border-radius: 8px;\n  --padding-start: 12px;\n  border-radius: 8px;\n\n  .toggle-icon {\n    font-size: 2rem;\n    color: var(--ion-color-secondary-contrast);\n  }\n\n  ion-label {\n    color: var(--ion-color-secondary-contrast) !important;\n  }\n\n  ion-toggle {\n    --track-background: var(--ion-color-toggle-track);\n    --track-background-checked: var(--ion-color-medium);\n    --handle-background: var(--ion-color-secondary-contrast);\n    --handle-background-checked: var(--ion-color-secondary-contrast);\n  }\n}\n\n.collapsable-section {\n  .field-item {\n    --min-height: 52px;\n  }\n\n  .empty-label {\n    font-size: 0.85rem;\n    font-style: italic;\n    opacity: 0.6;\n  }\n\n  .add-btn {\n    height: 32px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
